<template>
    <div class="engine-chapter-base" id="engine">
        <div class="container">
            <a-row class="inner">
                <a-col :sm="{ span: 12, push: 12 }">
                    <div class="engine-card-base">
                        <div class="engine-card">
                            <div class="card">
                                <div class="inner">
                                    <img src="/assets/lightdemo.png">
                                </div>
                            </div>
                        </div>
                        <div class="engine-card">
                            <div class="card">
                                <div class="inner">
                                    <img src="/assets/canvasdemo.png">
                                </div>
                            </div>
                        </div>
                        <div class="engine-card">
                            <div class="card">
                                <div class="inner">
                                    <img src="/assets/chiyademo.jpg">
                                </div>
                            </div>
                        </div>
                    </div>
                </a-col>
                <a-col :sm="{ span: 12, pull: 12 }">
                    <div class="content">
                        <div class="section-header">
                            <h2>关于引擎</h2>
                            <feature-icon color="teal" icon="rocket" class="develop-icon"/>
                        </div>
                        <p><span>广场上的魔塔基于自研引擎制作，内置了大量辅助功能以提供流畅的拆塔体验。同时，广场上的所有游戏都有在线版本，不必下载即可游玩</span></p>
                        <a href="https://h5mota.com/games/tutorial/">
                            <p class="link">游玩教程塔 <a-icon type="right"></a-icon></p>
                        </a>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
import FeatureIcon from './FeatureIcon.vue'
export default {
  components: { FeatureIcon },

}
</script>

<style lang="less">
@-webkit-keyframes floating {
    0% {
        -webkit-transform: translateY(0px) rotateY(350deg);
                transform: translateY(0px) rotateY(350deg);
    }
    50% {
        -webkit-transform: translateY(20px) rotateY(350deg);
                transform: translateY(20px) rotateY(350deg);
    }
    100% {
        -webkit-transform: translateY(0px) rotateY(350deg);
                transform: translateY(0px) rotateY(350deg);
    }
}
@keyframes floating {
    0% {
        -webkit-transform: translateY(0px) rotateY(350deg);
                transform: translateY(0px) rotateY(350deg);
    }
    50% {
        -webkit-transform: translateY(20px) rotateY(350deg);
                transform: translateY(20px) rotateY(350deg);
    }
    100% {
        -webkit-transform: translateY(0px) rotateY(350deg);
                transform: translateY(0px) rotateY(350deg);
    }
}
.engine-chapter-base,
.engine-chapter-base * {
    -webkit-transition: 0.4s all;
    -o-transition: 0.4s all;
    transition: 0.4s all;
}
.engine-chapter-base {
    margin-top: 10px;
    padding-top: 40px;
    min-height: 400px;
    @media (min-width: 992px) {
        margin-top: 80px !important;
        padding-top: 30px;
        .content {
            margin-top: 10px;
        }
    }
    @media (min-width: 768px) {
        margin-top: 30px;
    }
    @media (max-width: 767px) {
        min-height: 300px;
        padding-top: 0;
        margin-top: 0;
        .section-header {
            padding-top: 20px;
        }
        .feature-icon-base {
            display: none;
        }
    }
    .container {
        padding-left: 50px;
        padding-right: 50px;
        .content {
            text-align: right;
            color: black;
        }
    }
    .engine-card-base {
        margin-right: 0;
        margin-left: auto;
        position: relative;
        height: 300px;
        width: 260px;
        -webkit-perspective: 600px;
                perspective: 600px;
        .engine-card {
            position: absolute;
            -webkit-perspective: 600px;
                    perspective: 600px;
            height: 100%;
            width: 100%;
            -webkit-transform-origin: 0 50%;
                    transform-origin: 0 50%;
            @media (min-width: 1200px) {
                &:nth-child(1) .card {
                    left: -280px !important;
                }
                &:nth-child(2) .card {
                    left: -120px !important;
                }
            }
            &:nth-child(1) {
                -webkit-transform: scale(0.6);
                        transform: scale(0.6);
                .card {
                    left: -140px;
                    .inner {
                        opacity: 0.6;
                    }
                }
            }
            &:nth-child(2) {
                -webkit-transform: scale(0.8);
                        transform: scale(0.8);
                .card {
                    -webkit-animation-delay: 800ms;
                            animation-delay: 800ms;
                    left: -60px;
                    .inner {
                        opacity: 0.8;
                    }
                    width: 340px;
                }
            }
            &:nth-child(3) .card {
                -webkit-animation-delay: 1600ms;
                        animation-delay: 1600ms;
            }
            .card {
                position: absolute;
                -webkit-transform-origin: 50% 50%;
                        transform-origin: 50% 50%;
                height: 300px;
                width: 260px;
                border-radius: 20px;
                background: white;
                -webkit-transform: rotateY(350deg);
                        transform: rotateY(350deg);
                -webkit-animation: floating 8s infinite;
                        animation: floating 8s infinite;
                -webkit-transition-timing-function: ease-in-out;
                    -o-transition-timing-function: ease-in-out;
                        transition-timing-function: ease-in-out;
                .inner {
                    border-radius: 20px;
                    -webkit-box-shadow: inset 0 4px 7px 1px #ffffff, inset 0 -5px 20px rgba(173, 186, 204, 0.25), 0 2px 6px rgba(0, 21, 64, 0.14), 0 10px 20px rgba(0, 21, 64, 0.05);
                            box-shadow: inset 0 4px 7px 1px #ffffff, inset 0 -5px 20px rgba(173, 186, 204, 0.25), 0 2px 6px rgba(0, 21, 64, 0.14), 0 10px 20px rgba(0, 21, 64, 0.05);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
    @media (min-width: 768px) {
        .section-header .feature-icon-base {
            margin-right: -63px;
        }
        .section-header * {
            display: inline-block;
        }
        .section-header h2 {
            position: relative;
            top: -33px;
            margin-right: 10px;
            margin-bottom: 0;
        }
        .content p {
            margin-right: -17px;
        }
    }
    @media (max-width: 991px) and (min-width: 768px) {
        padding-top: 60px;
        .engine-card-base {
            -webkit-transform: scale(0.8);
                    transform: scale(0.8);
        }
    }
    @media (max-width: 767px) {
        padding-top: 0px;
        .container .content {
            text-align: center;
            margin-top: -40px;
        }
        .engine-card-base {
            -webkit-transform: scale(0.6);
                    transform: scale(0.6);
            margin: auto;
        }
    }
}
</style>
